//TODO: fsd
import { SpeedUpBar } from '@/features/compliance';
import { AddToFavorites } from '@/features/favorite-payment/ui';

import { SuccessIcon } from '@/shared/assets';
import { Button } from '@/shared/ui';

interface SuccessPaymentModalProps {
  onDone: VoidFunction;
  mainContent: React.ReactNode;
  onToggle?: (checked: boolean) => void;
  hasSwitch?: boolean;
  id: string;
  isFav?: boolean;
  isInner?: boolean;
}

export const SuccessPaymentModal = ({
  onDone,
  mainContent,
  hasSwitch,
  id,
  isFav,
  isInner,
}: SuccessPaymentModalProps) => {
  return (
    <div className="flex min-h-[532px] w-full flex-col items-center pt-3">
      <img className="h-[120px] w-[120px]" src={SuccessIcon} alt="success" />
      <div className="mt-10 w-full px-10">{mainContent}</div>
      <div className="mt-auto flex w-full flex-col gap-1">
        {hasSwitch && (
          <div className="w-full rounded-[20px] bg-base-300 p-6">
            <AddToFavorites id={id} isFav={isFav} />
          </div>
        )}
        {!isInner && <SpeedUpBar paymentId={id} variant="transaction" onAdd={onDone} />}
        <Button size="lg" onClick={onDone}>
          Done
        </Button>
      </div>
    </div>
  );
};
